import React from 'react';

const AttentionAlert = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Ikon varning"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9999 3.01979L26.5898 25.0842C26.5925 25.0888 26.5963 25.0978 26.5985 25.1118C26.599 25.1148 26.5993 25.118 26.5996 25.1212H1.4005C1.40115 25.1136 1.40238 25.1066 1.40396 25.1005C1.40635 25.0912 1.40903 25.0859 1.40998 25.0842L13.9999 3.01979ZM12.942 2.04894C13.2514 1.50676 13.9168 1.21066 14.5382 1.5382L14.5603 1.54981L14.6637 1.61409L14.6833 1.62824C14.8397 1.74115 14.9654 1.88698 15.0578 2.04894L27.8058 24.3904C28.1538 25.0003 28.0335 25.8617 27.4313 26.2964C27.2362 26.4372 27.0002 26.5212 26.7479 26.5212H1.25191C0.457824 26.5212 0 25.7836 0 25.133C0 24.8754 0.0647049 24.617 0.194002 24.3904L12.942 2.04894Z"
        fill="#353636"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9297 10.9509C15.9297 10.9734 15.9293 10.9958 15.9286 11.0182C15.9293 11.0391 15.9297 11.0602 15.9297 11.0816C15.9297 11.2318 15.9069 11.4414 15.8614 11.7105L14.3886 18.9956C14.3513 19.1802 14.1891 19.3129 14.0007 19.3129C13.8117 19.3129 13.6491 19.1793 13.6125 18.9939L12.1728 11.7105C12.1303 11.5045 12.1011 11.331 12.085 11.1902C12.0752 11.1044 12.0703 11.0306 12.0703 10.969L12.0703 10.961L12.0703 10.9509C12.0703 9.88511 12.9343 9.02115 14 9.02115C15.0658 9.02115 15.9297 9.88511 15.9297 10.9509ZM14.9098 22.7216C14.6587 22.9738 14.3554 23.0999 14 23.0999C13.6446 23.0999 13.3413 22.9738 13.0902 22.7216C12.8391 22.4693 12.7135 22.1647 12.7135 21.8076C12.7135 21.4584 12.8391 21.1576 13.0902 20.9054C13.3413 20.6531 13.6446 20.527 14 20.527C14.3554 20.527 14.6587 20.6531 14.9098 20.9054C15.1609 21.1576 15.2865 21.4584 15.2865 21.8076C15.2865 22.1647 15.1609 22.4693 14.9098 22.7216Z"
        fill="#353636"
      />
      <defs></defs>
    </svg>
  );
};
export default AttentionAlert;
